import React from 'react';
import Box from '@mui/material/Box';
import { GridOverlay } from '@mui/x-data-grid';

const DatagridNoRowsOverlay: React.FC<any> = ({ message = 'No Data' }: any) => {
  return (
    <GridOverlay>
      <Box>{message}</Box>
    </GridOverlay>
  );
};

export default React.memo(DatagridNoRowsOverlay);
